export const numberWithCommas = (x: any) => {
    const n = +x;
    // return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return n.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
};
